<template>
<div class="flex justify-between items-center py-2">
  <AppInputLabel :has-margin="false" :name="label" :label="label" :hasError="false" :required="false" />
  <div  @click="handleChange(!modelValue)" class="ml-2 relative w-[40px] h-[8px]  flex justify-between items-center ">
    
      <svg class="absolute inset-0 w-full h-full px-[15px]" xmlns="http://www.w3.org/2000/svg" width="40" height="12" viewBox="0 0 40 8" :fill="modelValue ? 'var(--color-action)' : 'var(--color-normal-disabled)'">
          <path d="M0 0H40V8H0Z" />
        </svg>
    
      <i v-if="!modelValue" class="fas fa-circle-xmark absolute left-0 top-1/2 transform -translate-y-1/2 text-normal-disabled"></i> 
      <i v-if="modelValue" class="fas fa-circle-check absolute right-0 top-1/2 transform -translate-y-1/2  text-action"></i>
  
  </div>
</div>
</template>
<script setup lang="ts">
import { toRef } from "vue";
import AppInputLabel from "./AppInputLabel.vue";

const emit = defineEmits(["change", "update:modelValue"]);
const prop = defineProps({
  label: {
    type: String
  },
  modelValue: {
    type: Boolean,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const isDisabled = toRef(prop, "disabled");
const handleChange = (isChecked:boolean) => {
  if (isChecked !== prop.modelValue && !isDisabled.value) {
    emit("update:modelValue", isChecked);
    emit("change", isChecked);
  }
};
</script>
